export default __webpack_public_path__ + "static/media/surge-news.a81d6093.svg";